import React, { ReactNode } from "react";

import notification from "antd/es/notification";
import { defineMessages, IntlShape } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/enum";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";

const messages = defineMessages({
  unableToEditDescription: {
    id: "recordPane.details.unableToEdit.description",
    defaultMessage:
      "This record requires <b>{fieldNames}</b> to be filled to make any changes, but you do not have access to edit them. Please contact your administrator to update your permissions.",
    description:
      "Text of the notification shown when user is not able to edit a record due to inaccessible fields",
  },
  unableToEditTitle: {
    id: "recordPane.details.unableToEdit",
    defaultMessage: "Unable to edit record",
    description:
      "Notification shown when user is not able to edit a record due to inaccessible fields",
  },
});

const showCannotEditNotification = (
  intl: IntlShape,
  entityType: EntityType.ACTIVITY | EntityType.COMPANY | EntityType.DEAL | EntityType.PERSON,
  fieldNames: string[]
) => {
  const fieldModel = getFieldModelByEntityType(entityType);
  const description = intl.formatMessage(messages.unableToEditDescription, {
    b: (texts: ReactNode[]) => <b>{texts}</b>,
    fieldNames: intl.formatList(
      fieldNames.map(
        (fieldName) => `"${fieldModel.getByName(fieldName)?.displayName ?? fieldName}"`
      ),
      { type: "conjunction" }
    ),
  });
  const key = "unableToEdit";
  notification.error({
    description,
    duration: null,
    key,
    message: intl.formatMessage(messages.unableToEditTitle),
  });
};

export default showCannotEditNotification;
